import gsap from 'gsap';

export default function initSearchClear() {
  document.querySelectorAll('.field-holder').forEach((holder) => {
    const input = holder.querySelector('input[type="search"]');
    const clearBtn = holder.querySelector('.clear-btn');
    const form = input.closest('form');
    if (!clearBtn) return;

    function updateClearBtn() {
      gsap.set(clearBtn, { autoAlpha: input.value ? 1 : 0 });
    }

    clearBtn.addEventListener('click', () => {
      input.value = '';
      input.focus();
      updateClearBtn();
      if(form) form.submit();
    });

    input.addEventListener('input', updateClearBtn);

    updateClearBtn();
  });
}
